<template>
  <ol class="list">
    <li
      v-for="{ id, text, items } in parsedContents"
      :key="id"
      class="list-item"
    >
      <NuxtLink class="link" :to="{ hash: `#${id}` }">{{ text }}</NuxtLink>
      <ArticleTableOfContentsList v-if="items.length" :contents="items" />
    </li>
  </ol>
</template>

<script setup lang="ts">
// Generated types are wrong
// Real type is:
import type { RecursiveContents } from '@/types/utils'

const props = defineProps<{ contents: RecursiveContents[] }>()

// This is temporary as backend inconsistently sends
// array as array or as a string
const getItems = (items: string | RecursiveContents[]): RecursiveContents[] => {
  if (Array.isArray(items)) {
    return items
  } else if (typeof items === 'string') {
    return JSON.parse(items)
  }

  return []
}

const parsedContents = props.contents.map(({ items, ...rest }) => ({
  items: getItems(items),
  ...rest
}))
</script>

<style scoped lang="scss">
.list {
  padding-left: rem(5px);
  font-size: rem(15px);
  font-weight: 400;
  line-height: 165%;
  color: $layout-text-02;
  letter-spacing: 0.15px;
  list-style-position: inside;
  list-style-type: none;
  counter-reset: item;

  :deep(.list) {
    margin-left: rem(-7px);
  }
}

.list > .list-item {
  display: table;
  counter-increment: item;
}

// solution: https://stackoverflow.com/a/26245056
.list > .list-item::before {
  display: table-cell;
  padding-right: rem(5px);
  content: counters(item, '.') '. ';
}

.list-item .list > .list-item::before {
  content: counters(item, '.') ' ';
}

.link {
  display: inline-block;

  .list-item > & {
    margin-bottom: rem(4px);
  }
}
</style>
